import { render, staticRenderFns } from "./salaryDialog.vue?vue&type=template&id=323dfaae&scoped=true"
import script from "./salaryDialog.vue?vue&type=script&lang=js"
export * from "./salaryDialog.vue?vue&type=script&lang=js"
import style0 from "./salaryDialog.vue?vue&type=style&index=0&id=323dfaae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323dfaae",
  null
  
)

export default component.exports